import {
  tourAnchorSelector,
  tourContextSelector,
} from '@/lib/productTours/anchors'

const isVisible = (element: Element): boolean => element.getClientRects().length > 0

/** Premier élément visible portant l'ancre : une ancre cachée (onglet inactif, `display: none`) ne compte pas. */
export const findAnchorElement = (anchor: string): HTMLElement | null => {
  const candidates = document.querySelectorAll<HTMLElement>(tourAnchorSelector(anchor))
  return Array.from(candidates).find(isVisible) ?? null
}


export const isAnchorDisplayable = (anchor: string): boolean =>
  findAnchorElement(anchor) !== null

/** Le marqueur du contexte (écran et variante) est à l'écran. */
export const isContextDisplayed = (context: string): boolean =>
  Array.from(document.querySelectorAll(tourContextSelector(context))).some(
    isVisible
  )

/**
 * Une modale MUI est ouverte (Dialog, Drawer temporaire, Menu, Popover) : un tour automatique
 * attend sa fermeture. C'est ainsi que la modale « Nouveautés » passe avant.
 */
export const isMuiModalOpen = (): boolean =>
  document.querySelector('.MuiModal-root:not(.MuiModal-hidden)') !== null
